import ReactBootstrapSlider from 'react-bootstrap-slider';
import React, {memo, useState, useCallback, useEffect} from 'react';
import { connect } from "react-redux";
import Notes from 'midi/Notes.js';
import BasicWaveform from 'components/waveform/BasicWaveform.js';
import Note from './Note.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

const HorizontalPianoComponent = memo(({selectedSampler, onClickSampler, sampleDragging, instrument}) => {
    return (
        <div className="horizontal-piano-container">
          <div className="horizontal-piano">
           <Octave
              selectedSampler={selectedSampler}
              onClickSampler={onClickSampler}
              octave={1}
              instrument={instrument}
              sampleDragging={sampleDragging}/>
           <Octave
              selectedSampler={selectedSampler}
              onClickSampler={onClickSampler}
              octave={2}
              instrument={instrument}
              sampleDragging={sampleDragging}/>
            <Octave
              selectedSampler={selectedSampler}
              onClickSampler={onClickSampler}
              octave={3}
              instrument={instrument}
              sampleDragging={sampleDragging}/>
           
            <Octave
              selectedSampler={selectedSampler}
              onClickSampler={onClickSampler}
              octave={4}
              instrument={instrument}
              sampleDragging={sampleDragging}/>
            <Octave
              selectedSampler={selectedSampler}
              onClickSampler={onClickSampler}
              octave={5}
              instrument={instrument}
              sampleDragging={sampleDragging}/>
            <Octave
              selectedSampler={selectedSampler}
              onClickSampler={onClickSampler}
              octave={6}
              instrument={instrument}
              sampleDragging={sampleDragging}/>
             <Octave
              selectedSampler={selectedSampler}
              onClickSampler={onClickSampler}
              octave={7}
              instrument={instrument}
              sampleDragging={sampleDragging}/>
 
         </div>
        </div>
    );
});

function Octave(props) {
    let notes = Notes.NOTES.map(x => {
        x = x.getCopy();
        x.octave = props.octave;
        return x;
    });
    return (
        <div className="octave">
          <div className="octave-label">
            {notes[0].toString()}
          </div>
          {notes.map(
              x =>
                  <Note
                        key={x.toString()}
                        selectedSampler={props.selectedSampler}
                        onClickSampler={props.onClickSampler}
                        sampleDragging={props.sampleDragging}
                        octave={props.octave}
                        transpose={x.getTranspose()}
                        note={x}
                        instrument={props.instrument}
                    />)}
        </div>
    );
}


export default HorizontalPianoComponent;
